window.addEventListener('DOMContentLoaded', () => {
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}

  gtag('consent', 'default', {
    'ad_storage': 'granted',
    'ad_user_data': 'granted',
    'ad_personalization': 'granted',
    'analytics_storage': 'granted',
    'functionality_storage': 'granted',
    'personalization_storage': 'granted',
    'security_storage': 'granted',
    'wait_for_update': 500
  });
  gtag('consent', 'update', {
    'ad_storage': 'granted',
    'ad_user_data': 'granted',
    'ad_personalization': 'granted',
    'analytics_storage': 'granted',
    'functionality_storage': 'granted',
    'personalization_storage': 'granted',
    'security_storage': 'granted'
  });
});

/* CH - Custom link tracking */

window.addEventListener('DOMContentLoaded', () => {
  (function persistMatomoCidToCart() {
    // console.log('[persistMatomoCid] Running… document.cookie=', document.cookie);
    const m = document.cookie.match(/_pk_id\.[^=]+=([^\.]+)\./);
    if (!m) {
      // console.warn('[persistMatomoCid] No _pk_id cookie found');
      return;
    }
    const cid = m[1];
    // console.log('[persistMatomoCid] Found CID:', cid);

    if (sessionStorage.getItem('matomoCidSaved') === cid) {
      // console.log('[persistMatomoCid] Already saved this CID');
      return;
    }

    sessionStorage.setItem('matomoCidSaved', cid);
    // console.log('[persistMatomoCid] sessionStorage.matomoCidSaved set');

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: `attributes[matomoCid]=${encodeURIComponent(cid)}`
    })
    .catch(e => console.error('[persistMatomoCid] Fetch error:', e));
  })();
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".gatrack").forEach(function (el) {
    el.addEventListener("click", function () {
      const elLabel = el.getAttribute("data-gatrack-label") || "Unknown Element Label";
      const elCategory = el.getAttribute("data-gatrack-category") || "Unknown Element Category";
      const elUrl = el.href || "No Element URL";

      if (window.gtag) {
        gtag("event", "click", {
          event_category: elCategory,
          event_label: elLabel,
          link_url: elUrl
        });
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".main-nav__item").forEach(function (menuItem) {
    menuItem.addEventListener("click", function () {
      let menuCategory = "Unknown Category";
      let menuItemName = menuItem.textContent.trim();
      let menuUrl = menuItem.href || "No URL";

      // Find the closest parent summary (top-level menu name)
      let parentDetails = menuItem.closest("details");
      if (parentDetails) {
        let parentSummary = parentDetails.querySelector("summary .main-nav__item-content");
        if (parentSummary) {
          menuCategory = parentSummary.textContent.trim();
        }
      }

      if (window.gtag) {
        gtag("event", "click", {
          event_category: "Main Menu",
          event_label: menuItemName,
          menu_category: menuCategory,
          link_url: menuUrl
        });
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function() {
  (function() {
    function getQueryParam(url, param) {
      const urlParams = new URLSearchParams(new URL(url).search);
      return urlParams.get(param);
    }

    function trackClickEvent(event) {
      const target = event.target.closest("a");
      if (!target) return;

      // Check if the click happened inside a .slideshow or .gallery container
      const container = target.closest(".slideshow, .gallery");
      if (!container) return;

      const gaCat = getQueryParam(target.href, 'gaCat');
      const gaLab = getQueryParam(target.href, 'gaLab');
      const landingUrl = target.href;
      const pageLocation = window.location.href;

      if (gaCat && gaLab && window.gtag) {
        gtag("event", "click", {
          event_category: gaCat,
          event_label: gaLab,
          link_url: landingUrl,
          page_location: pageLocation
        });
      }
    }

    document.addEventListener("click", trackClickEvent);
  })();
});

/* CH - Custom link tracking */